import * as moment from 'moment';
import { ICenterBase, ICprScoreAudit } from '@nkr/models/index';

interface IState {
    data: ICprScoreAudit[],
    center: ICenterBase,
    reportStart: string,
    newReportStart: string,
    reportEnd: string,
    newReportEnd: string,
    customRange: boolean,
    included: boolean,
    favorable: boolean,
    compatible: boolean,
    transplanted: boolean,
    expandHelp: boolean
}

const initialState: IState = {
    data: [],
    reportStart: moment().startOf('month').subtract(6, 'months').format('YYYY-MM-DD'),
    newReportStart: moment().startOf('month').subtract(6, 'months').format('YYYY-MM-DD'),
    reportEnd: moment().startOf('month').subtract(1, 'days').format('YYYY-MM-DD'),
    newReportEnd: moment().startOf('month').subtract(1, 'days').format('YYYY-MM-DD'),
    customRange: false,
    center: null,
    included: true,
    favorable: false,
    compatible: false,
    transplanted: null,
    expandHelp: false
};

type Action =
    | { type: 'initialize', payload: IState }
    | { type: 'afterGetData', payload: { data: ICprScoreAudit[], center: ICenterBase, reportStart: string, newReportStart: string, reportEnd, newReportEnd: string, customRange: boolean, included: boolean, favorable: boolean, compatible: boolean, transplanted: boolean } }
    | { type: 'refreshData', payload: { data: ICprScoreAudit[], center: ICenterBase, reportStart: string, newReportStart: string, reportEnd, newReportEnd: string } }
    | { type: 'updateField', payload: { name: string, value: any } }
    | { type: 'compatibleOrIncludedTotalOnly', payload: { included: boolean, favorable: boolean, compatible: boolean, transplanted: boolean } }

const reducer = (state: IState, action: Action): IState => {
    switch (action.type) {
        case 'initialize':
            return { ...action.payload };

        case 'afterGetData':
            return { ...state, ...action.payload };

        case 'refreshData':
            return { ...state, ...action.payload };

        case 'updateField':
            return { ...state, [action.payload.name]: action.payload.value };

        case 'compatibleOrIncludedTotalOnly':
            return { ...state, included: action.payload.included, favorable: action.payload.favorable, compatible: action.payload.compatible, transplanted: action.payload.transplanted };

        default:
            return { ...state };
    }
}

export { initialState, reducer };